import script from "./LandingFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingFooter.vue?vue&type=script&setup=true&lang=js"

import "./LandingFooter.vue?vue&type=style&index=0&id=3eb54cf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb54cf4"]])

export default __exports__